import { useMemo } from "react";
import JoditEditor from "jodit-react";
import { useEffect } from "react";
import { createListMediaFile } from "../../../../helpers/fakebackend_helper";
const buttons = [
  "source",
  "|",
  "bold",
  "italic",
  "underline",
  "strikethrough",
  "eraser",
  "|",
  "superscript",
  "subscript",
  "ul",
  "ol",
  "indent",
  "outdent",
  "|",
  "font",
  "fontsize",
  "brush",
  "paragraph",
  "|",
  "classSpan",
  "spellcheck",
  "cut",
  "copy",
  "paste",
  "selectall",
  "hr",
  "table",
  "link",
  "symbol",
  "image",
  // "file", // default insert file of jodit
  // below is custom insert file
  {
    name: "Insert File",
    tooltip: "Insert File",
    iconURL: "./icons-editor/file-custom.png",
    exec: function (editor) {
      let html = editor.value;
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "*/*"; // hoặc lọc kiểu: ".pdf,.docx,.zip"
      input.onchange = async () => {
        const file = input.files[0];
        console.log("file =>", file);
        if (!file) return;

        const formData = new FormData();
        formData.append("files", file);
        formData.append("fileName", file.name);
        formData.append("filetype", "pdf");

        try {
          console.log(file, file.name, file.type);
          createListMediaFile(formData, {}).then((res) => {
            const fileUrl = res.data[0]?.preview_url ?? ""; // adjust to your API response
            editor.s.insertHTML(
              `<a href="${fileUrl}" target="_blank" rel="noopener noreferrer">${file.name}</a>`
            );
          });
          // const response = await axios.post("/your-upload-endpoint", formData, {
          //   headers: {
          //     "Content-Type": "multipart/form-data",
          //   },
          // });
          // const fileUrl = response.data?.url; // adjust to your API response
          // editor.s.insertHTML(
          //   `<a href="${fileUrl}" target="_blank" rel="noopener noreferrer">${file.name}</a>`
          // );
        } catch (error) {
          console.error("Upload failed:", error);
          alert("Upload failed");
        }
      };

      input.click();
    },
  },
  "video",
  "|",
  "align",
  "undo",
  "redo",
  "fullsize",
  "source",
  "preview",
  "|",
  "fullsize",
  "search",
  "code",
  "print",
  "about",
];

export default function JoditEditorGlobal(props) {
  const { content, setContent, editorRef, placeholder } = props;
  const cleanContent = content.replace("<p><br></p>", "");
  const config = useMemo(
    () => ({
      readonly: false,
      autofocus: true,
      // extraButtons: [
      //   {
      //     name: "customButton",
      //     icon: "🌟", // Or use an SVG string
      //     tooltip: "Insert Hello",
      //     exec: (editorInstance) => {
      //       editorInstance.s.insertHTML(
      //         "<strong>Hello from React button!</strong>"
      //       );
      //     },
      //   },
      // ],
      buttons: buttons,
      tabIndex: 1,
      languages: "vi",
      height: 500,
      extraPlugins: ["stat"],
      cleanHTML: {
        fillEmptyParagraph: true,
        removeEmptyElements: true,
        replaceNBSP: true,
      },
      placeholder: placeholder,
      uploader: {
        insertImageAsBase64URI: false,
        url: "https://xdsoft.net/jodit/finder/?action=fileUpload", // 👈 your upload handler
        imagesExtensions: [
          "jpg",
          "png",
          "jpeg",
          "gif",
          "svg",
          "webp",
          "avif",
          "bmp",
          "tiff",
          "ico",
          "jfif",
          "heic",
          "docx",
          "pdf",
        ],
      },
      filebrowser: {
        ajax: {
          url: "/api/files",
        },
      },
      beautyHTML: false,
      toolbarButtonSize: "large",
      controls: {
        lineHeight: {
          list: {
            1: "1",
            1.1: "1.1",
            1.2: "1.2",
            1.3: "1.3",
            1.4: "1.4",
            1.5: "1.5",
            1.6: "1.6",
            1.7: "1.7",
            1.8: "1.8",
            1.9: "1.9",
            2: "2",
          },
        },
      },
      toolbarAdaptive: false,
      events: {
        afterInit: () => {
          const cleanContent = content.replace("<p><br></p>", "");
          setContent(cleanContent);
        },
      },
      style: {
        fontSize: "18px",
        lineHeight: "1.6",
        fontFamily: "Mulish, Helvetica, Arial, sans-serif",
      },
    }),
    [placeholder]
  );
  const sanitizeContent = (html) => {
    return html
      .replace(/\uFEFF/g, "") // Xóa BOM
      .replace("<p><br></p>", "")
      .replace(`<figcaption style="text-align: center;"><br></figcaption>`, "")
      .replace(`<figcaption><br></figcaption>`, "");
  };
  useEffect(() => {
    if (content.includes("<p><br></p>")) {
      const cleanContent = content.replace("<p><br></p>", "");
      setContent(cleanContent);
    }
  }, [content]);
  return (
    <JoditEditor
      ref={editorRef}
      value={cleanContent}
      config={config}
      onBlur={(newContent) => setContent(sanitizeContent(newContent))}
    />
  );
}
